export default String.raw`
<g id="Newsletter rozbudowany/szary/mobile">
    <g id="Newsletter rozbudowany/szary/mobile_2">
        <rect width="360" height="513" class="newsletterBgColor"/>
        <g id="Frame 675" class="newsletterFont">
            <text xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="16" y="42.5455">TRANSLATION_Prv_JoinNewsletter_A_MobA</tspan><tspan x="16" y="66.5455">TRANSLATION_Prv_JoinNewsletter_A_MobB</tspan></text>
        </g>
        <g id="zawartosc">
            <g id="Frame 253" class="newsletterFont">
                <g id="Korzysci newsletter">
                    <g id="Interface/Newspaper" transform="translate(16, 89)">
                        <use href="#newspaper" width="32" height="32"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="64" y="109.091">TRANSLATION_Prv_NewMagazines</tspan></text>
                </g>
                <g id="Korzysci newsletter_2">
                    <g id="Interface/Percent" transform="translate(16, 137)">
                       <use href="#percent" width="32" height="32"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="64" y="157.091">TRANSLATION_Prv_UniqueOffers</tspan></text>
                </g>
                <g id="Korzysci newsletter_3">
                    <g id="Interface/delivery" transform="translate(16, 185)">
                        <use href="#truck" width="32" height="32"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="64" y="205.091">TRANSLATION_Prv_DeliverySchedule</tspan></text>
                </g>
                <g id="Korzysci newsletter_4">
                    <g id="Interface/idea" transform="translate(16, 233)">
                        <use href="#lightbulb-on" width="32" height="32"></use>
                    </g>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" font-weight="500" letter-spacing="0px"><tspan x="64" y="253.091">TRANSLATION_Prv_InspirationsAndTips</tspan></text>
                </g>
            </g>
            <g id="Frame 247">
                <text class="newsletterFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="16" y="304.091">TRANSLATION_Prv_JoinNewsletter_B_MobA</tspan><tspan x="16" y="324.091">TRANSLATION_Prv_JoinNewsletter_B_MobB</tspan></text>
                <g id="1. Text Input Basic">
                    <g id="Input">
                        <rect x="16.5" y="345.5" width="327" height="39" rx="4.5" class="inputsBgColor bgColorFont--stroke"/>
                        <g id="Interface/Mail" transform="translate(32, 353)" class="bgColorFont">
                            <use href="#envelope" width="24" height="24"></use>
                        </g>
                        <text class="newsletterFont" xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="64" y="370.091">TRANSLATION_Prv_NewsletterInputPlaceholder</tspan></text>
                    </g>
                </g>
                <g id="Frame 263">
                    <g id="Checkbox" class="inputsBgColor bgColorFont--stroke">
                        <rect id="Base" x="20.5" y="405.5" width="15" height="15" rx="3.5"/>
                    </g>
                    <text class="newsletterFont" xml:space="preserve" style="white-space: pre" font-size="12" letter-spacing="0px"><tspan x="56" y="413.364">TRANSLATION_Prv_IAgree_MobA</tspan><tspan x="56" y="429.364">TRANSLATION_Prv_IAgree_MobB</tspan></text>
                </g>
                <g id="Primary button">
                    <rect x="16" y="449" width="328" height="40" rx="5" class="btnSolidBgColor"/>
                    <text class="btnSolidTextColor" id="Button" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="139.183" y="474.091">TRANSLATION_Prv_SaveMe</tspan></text>
                </g>
            </g>
        </g>
    </g>
</g>
`;